<p-dialog ngClass="notes-dialog" [draggable]="false" [resizable]="false" [header]="title" [(visible)]="visible"
  [modal]="true" [breakpoints]="{ '1200px': '75vw', '575px': '90vw' }" [style]="{width: '50vw'}" (onHide)="close()">
  <div class="notes-content">{{notes}}</div>
</p-dialog>
